import { getTemplate } from '@/api/cloudMonitor/templateList'
import { listConfig, updateConfig } from "@/api/configurationlist";
import i18n from "../common/lang";
export const terminalForm = {
  data() {
    const isSelect = (rule, value, callback) => {
      if (value.id) {
        callback()
      } else {
        callback(new Error(i18n.t('lang.terminalList.form1')))
      }
    }
    const checkDevice = (rule, value, callback) => {
      if (value.deviceDid) {
        callback()
      } else {
        callback(new Error(i18n.t('lang.terminalList.form2')))
      }
    }
    const checkSid = (rule, value, callback) => {
      if (value==="") {
        callback(new Error(i18n.t('lang.terminalList.form3')))
      } else if (value < 0) {
        callback(new Error(i18n.t('lang.terminalList.form4')))
      } else if (value < 0 || value >= (this.terminalData.protocol==1?255:247)) {
        callback(new Error(i18n.t('lang.terminalList.form5') + (this.terminalData.protocol==1?255:247)))
      } else {
        callback()
      }
    }
    const checkIp = (rule, value, callback) => {
      if (!value) {
        callback(new Error(i18n.t('lang.terminalList.form6')))
      } else {
        // 正则表达式,验证地址
        let ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/
        let domain = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
        let url = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/
        let ip6 = /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/
        // 动态设置服务器地址输入框样式，输入错误则输入框为红色
        if (ip.test(value) || domain.test(value) || url.test(value) || ip6.test(value)) {
          callback()
        } else {
          callback(new Error(i18n.t('lang.terminalList.form7')))
        }
      }
    }
    const checkport = (rule, value, callback) => {
      if (Number(value) <= 0) {
        callback(i18n.t('lang.terminalList.form8'))
      } else if (Number(value) > 65535) {
        callback(i18n.t('lang.terminalList.form8'))
      } else {
        callback()
      }
    }
    return {
      terminalData: {
        name: '',
        ip: '',
        port: '502',
        protocol: "1",
        // model:"1",//工作模式
        sid: '',
        serialPort: '',
        com: '',
        bps: '',
        dataBit: '',
        checkBit: '',
        stopBit: '',
        xon: '',
        type: '0',//模板类别
        device: {},
        template: {}
      },
      templateList: [], // 模板选项
      serialPortOptions: [], // 串口配置选项
      serialPortData: [],
      originalTemplate: {}, //'判断编辑时是否切换模板'
      originalPotocol: '1',
      comText: i18n.t('lang.terminalList.form10'), //数据加载时显示
      addRules: {
        name: [
          { required: true, message: i18n.t('lang.terminalList.form9'), trigger: 'blur' }
        ],
        protocol: [
          { required: true, message: i18n.t('lang.terminalList.form11'), trigger: ['blur', 'change'] }
        ],
        // model: [
        //   { required: true, message: '请选工作模式', trigger: ['blur', 'change']}
        // ],
        port: [
          { required: true, validator: checkport, message: i18n.t('lang.terminalList.form12'), trigger: 'change' }
        ],
        ip: [
          { required: true, validator: checkIp, trigger: ['blur', 'change'] }
        ],
        template: [
          { required: true, validator: isSelect, trigger: ['blur', 'change'] }
        ],
        device: [
          { required: true, validator: checkDevice, trigger: ['blur', 'change'] }
        ],
        sid: [
          { required: true, validator: checkSid, trigger: ['blur', 'change'] }
        ]
      },
      // 协议选项
      protoOptions: [
        { label: 'Modbus TCP', value: "1" },
        { label: 'Modbus RTU', value: "2" },
        { label: 'IO Control', value: "3" },
      ],
      // modTypeObj:{
      //   '0':'modbus',
      //   '1':'io control'
      // },
      modTypeOptions: [
        { label: 'Modbus', value: '0' },
        { label: 'IO Control', value: '1' },
      ]
    }
  },
  watch: {
    item: {
      immediate: true,
      handler: function () {
        if (this.item) {
          this.terminalData = this.item
          if (this.hasTemplate === true) {
            this.$set(this.terminalData, 'template', { id: '' })
            this.terminalData.template.id = this.item.mid
          }
        }
      }
    },
  },
  methods: {
    // 获取串口配置信息
    getConfig() {
      this.comText = this.$t('lang.Dialog.allocator')+'...'
      let arr = [
        {
          section: "serial",
          config: "smartlink",
          options: [
            { option: "parity" },
            { option: "data_bits" },
            { option: "stop_bits" },
            { option: "flow_ctrl" },
            { option: "baudrate" }
          ]
        }
      ]
      this.serialPortOptions = []
      listConfig(this.terminalData.device.deviceSn, this.terminalData.device.deviceDid, arr).then(res => {
        if (res.data.code === 0) {
          this.serialPortData = []
          if (res.data.data.mess) {
            let s_objects = res.data.data.mess[0].s_objects
            s_objects.forEach(item => {
              this.serialPortOptions.push(item)
              let ele = {
                label: item.sname,
                value: item.options,
                index: item.index
              }
              this.serialPortData.push(ele)
            })
            if (this.serialPortOptions.length <= 0) {
              this.comText = '无数据'
            }
            if(this.terminalData.com==''&&this.serialPortOptions.length>0){
              this.terminalData.com = this.serialPortOptions[0].sname
            }
          }
        } else {
          this.comText = '获取失败'
        }
      }).catch(() => {
        this.comText = '获取失败'
      })
    },
    // 返回表单数据给父组件
    getFormData() {
      return this.terminalData
    },
    // 进入表单时先清空数据
    clearData() {
      this.terminalData = {
        name: '',
        ip: '',
        port: '502',
        protocol: "1",//协议 1就是tcp,2是rtu,3是io
        sid: '',
        serialPort: '',
        com: '',
        bps: '',
        device: {},
        template: {},
        bps: '',
        dataBit: '',
        checkBit: '',
        stopBit: '',
        xon: '',
        type: '0',//模板类型
        model: "1",//工作模式
      }
      this.serialPortOptions = []
      this.comText = '无数据'
    },
    // 编辑时获取数据详情后处理数据
    handleData(data) {
      if (data.protocol == 1) {
        this.terminalData = {
          id: data.id, // 终端id
          pid: data.pid, // 协议表id
          name: data.name,
          did: data.did,
          mid: data.mid,
          protocol: data.protocol.toString(),
          ip: '',
          port: '',
          sid: '',
          type: data.type ? data.type.toString() : '0',
          model: "1",//工作模式
        }
        if (data.tcpProtocol) {
          this.terminalData.ip = data.tcpProtocol.ip
          this.terminalData.port = data.tcpProtocol.port
          this.terminalData.sid = data.tcpProtocol.sid
        }
        // this.terminalData.protocol = 1
      } else if (data.protocol == 2) {
        this.terminalData = {
          id: data.id,
          pid: data.pid, // 协议表id
          name: data.name,
          did: data.did,
          mid: data.mid,
          protocol: data.protocol.toString(),
          type: data.type ? data.type.toString() : '0',
          bps: '',
          dataBit: '',
          stopBit: '',
          sid: '',
          checkBit: '',
          serialPort: '',
          xon: '',
          com: ''
        }
        if (data.rtuProtocol) {
          this.terminalData.bps = data.rtuProtocol.bps
          this.terminalData.dataBit = data.rtuProtocol.dataBit,
            this.terminalData.stopBit = data.rtuProtocol.stopBit,
            this.terminalData.sid = data.rtuProtocol.sid,
            this.terminalData.checkBit = data.rtuProtocol.checkBit,
            this.terminalData.serialPort = data.rtuProtocol.serialPort,
            this.terminalData.xon = data.rtuProtocol.xon
          this.terminalData.com = data.rtuProtocol.com
        }
        // this.terminalData.protocol = 2
        // console.log(this.terminalData.protocol);
      } else if (data.protocol == 3) {
        this.terminalData = {
          id: data.id, // 终端id
          pid: data.pid, // 协议表id
          name: data.name,
          did: data.did,
          mid: data.mid,
          protocol: data.protocol.toString(),
          type: data.type ? data.type.toString() : '0'
        }
      }
    },
    //  // 协议发生变化
    //  protocalChange(val) {
    //    if(val == 2) {
    //      this.getConfig()
    //    }
    //    this.resetValidate()
    //    this.terminalData.protocol = val
    //  },
    // 串口选择变化
    serialPortChang(val) {
      if (val) {
        let serialObj = this.serialPortData.filter(item => {
          return item.label === val
        })
        console.log(serialObj[0]);
        this.terminalData.dataBit = serialObj[0].value.data_bits
        this.terminalData.stopBit = serialObj[0].value.stop_bits
        this.terminalData.bps = serialObj[0].value.baudrate
        this.terminalData.xon = serialObj[0].value.flow_ctrl
        this.terminalData.checkBit = serialObj[0].value.parity
        this.comIndex = serialObj[0].index
      }
    },
    // 提交表单前封装表单数据给后端
    setSubmitData(setData) {
      let submitData = {}
      console.log(setData);
      if (setData.protocol == 1) {
        submitData = {
          id: setData.id,
          name: setData.name,
          did: setData.did,
          mid: setData.template.id,
          protocol: "1",
          type: setData.type,
          tcpProtocol: {
            id: setData.pid,
            ip: setData.ip,
            port: parseInt(setData.port),
            sid: parseInt(setData.sid),
          }
        }
      } else if (setData.protocol == 2) {
        submitData = {
          id: setData.id,
          name: setData.name,
          did: setData.did,
          mid: setData.template.id,
          protocol: 2,
          type: setData.type,
          rtuProtocol: {
            id: setData.pid,
            bps: parseInt(setData.bps),
            dataBit: parseInt(setData.dataBit),
            stopBit: parseInt(setData.stopBit),
            sid: parseInt(setData.sid),
            checkBit: setData.checkBit,
            serialPort: setData.serialPort,
            com: setData.com,
            xon: setData.xon,
          }
        }
      } else if (setData.protocol == 3) {
        submitData = {
          id: setData.id,
          name: setData.name,
          did: setData.did,
          mid: setData.template.id,
          protocol: 3,
          type: setData.type,
          rtuProtocol: {
            id: setData.pid,
          }
        }
      }
      console.log('submit');
      console.log(submitData);
      return submitData
    },
    // 重置验证
    resetValidate() {
      this.$refs.addTerminal.clearValidate()
    },
    // 验证表单
    checkForm() {
      let flag = false
      this.$refs.addTerminal.validate(valid => {
        if (valid) {
          flag = true
        } else {
          flag = false
          return false
        }
      })
      return flag
    }
  }
}